module.exports = __webpack_public_path__ + "static/media/modify-hover.2f206e06.svg";